import { render, staticRenderFns } from "./claimDesc.vue?vue&type=template&id=046686a4&scoped=true"
import script from "./claimDesc.vue?vue&type=script&lang=js"
export * from "./claimDesc.vue?vue&type=script&lang=js"
import style0 from "./claimDesc.vue?vue&type=style&index=0&id=046686a4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "046686a4",
  null
  
)

export default component.exports